import type { FC } from "react";
import { useNavigate } from "react-router";
import { SignalEditorPage } from "./signalEditorPage.js";

/** The signal editor as a route element: closing returns to the signal list. */
export const SignalEditorRoute: FC = () => {
  const navigate = useNavigate();
  const handleClose = () => navigate(-1);

  return <SignalEditorPage onClose={handleClose} />;
};
